module.exports = __webpack_public_path__ + "img/main10.22fd3728.jpeg";